window.addEventListener( 'load', function() {

	const menuToggles = document.querySelectorAll( '.wp-block-menu-button' );
    const overlays = document.querySelectorAll( '.wp-block-menu__overlay' );

    function openClose( button ) {
        const   id = button.target.getAttribute('aria-controls'),
                    target = document.getElementById( id ),
                    overlay = target.querySelector( '.wp-block-menu__overlay' );
        if ( button.target.classList.contains( 'wp-block-menu-button--close' ) ) {
            target.setAttribute( 'aria-expanded', false );
            document.querySelector('html').classList.remove( 'no-scroll' );
            if ( overlay ) {
                overlay.classList.remove( 'visible' );
            }
        } else {
            target.setAttribute( 'aria-expanded', true );
            document.querySelector('html').classList.add( 'no-scroll' );
            if ( overlay ) {
                overlay.classList.add( 'visible' );
            }
        }
    }

	[...menuToggles].forEach( menuToggle => {        
        menuToggle.addEventListener( 'click', button => {
            openClose( button );
        } );		
	} );

    [...overlays].forEach( overlay => {        
        overlay.addEventListener( 'click', e => {    
            e.target.classList.remove( 'visible' );
            document.querySelector('html').classList.remove( 'no-scroll' );     
            document.querySelectorAll( '.wp-block-menu' ).forEach( menu => {
                menu.setAttribute( 'aria-expanded', false );
            } );
        } );		
	} );

} );